import undoStack from './undo-stack';
import redoStack from './redo-stack';

const pushUndoAction = (entry) => undoStack.get().push(entry);

const pushRedoAction = (entry) => redoStack.get().push(entry);

const popRedoAction = () => redoStack.get().pop();

const popUndoAction = () => undoStack.get().pop();

const clearUndoStack = () => undoStack.set([]);

const clearRedoStack = () => redoStack.set([]);

const isUndoEmpty = () => undoStack.get().length === 0;

const isRedoEmpty = () => redoStack.get().length === 0;

export default {
  pushRedoAction,
  pushUndoAction,
  popRedoAction,
  popUndoAction,
  clearUndoStack,
  clearRedoStack,
  isRedoEmpty,
  isUndoEmpty,
};
